import { render } from "./VirtualPackingSlipOrderDetails.vue?vue&type=template&id=eb452560"
import script from "./VirtualPackingSlipOrderDetails.vue?vue&type=script&lang=js"
export * from "./VirtualPackingSlipOrderDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__